<!--
	These divs are intentionally hidden, and their only purpose is to allow SV testers to read
	the application version and client version from the HTML element.
-->

<div style="display: none" data-testid="sh-device-portal-app-version">{{ appVersion }}</div>
<div style="display: none" data-testid="sh-device-portal-client-version">{{ clientVersion }}</div>

<router-outlet></router-outlet>
